import React, { FC } from 'react';
import { AnimatedLink } from '../../../../doctrine/components/animated-link/AnimatedLink';
import styles from './public_quote.module.scss';

type Props = {
  image?: {
    url: string;
  };
  quote_job?: string;
  quote_link?: string;
  quote_name?: string;
  quote_text?: string;
  linkText?: string;
};

export const PublicQuote: FC<Props> = ({
  image,
  quote_job,
  quote_link,
  quote_name,
  quote_text,
  linkText,
}) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img src={image?.url} alt="Visage client" height="128" />
    </div>
    <div className={styles.textContainer}>
      {/* eslint-disable-next-line react/no-danger */}
      <p
        className={styles.quote}
        dangerouslySetInnerHTML={{ __html: quote_text || '' }}
      />
      <div className={styles.nameJobContainer}>
        <span className={styles.name}>{quote_name}</span>
        {' · '}
        <span className={styles.job}>{quote_job}</span>
      </div>
      {quote_link && <AnimatedLink href={quote_link}>{linkText}</AnimatedLink>}
    </div>
  </div>
);
